// extracted by mini-css-extract-plugin
module.exports = {"promocode__form":"styles_promocode__form__2hL59","promocode__button":"styles_promocode__button__3jT7g"};